var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongLeftR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.168 7.50668C16.9491 6.72564 18.2154 6.72564 18.9964 7.50668L21.8249 10.3351C22.6059 11.1162 22.6059 12.3825 21.8249 13.1635L18.9964 15.992C18.2154 16.773 16.9491 16.773 16.168 15.992L13.3396 13.1635C13.1438 12.9678 12.9971 12.7415 12.8995 12.5H8.4896V16.75C8.4896 17.0481 8.31305 17.3179 8.03988 17.4373C7.76671 17.5566 7.44878 17.5029 7.23004 17.3003L1.83004 12.3003C1.67674 12.1584 1.5896 11.9589 1.5896 11.75C1.5896 11.5411 1.67674 11.3416 1.83004 11.1997L7.23004 6.19969C7.44878 5.99716 7.76671 5.9434 8.03988 6.06275C8.31305 6.1821 8.4896 6.45191 8.4896 6.75002V11H12.8989C12.9965 10.758 13.1434 10.5313 13.3396 10.3351L16.168 7.50668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongLeftR);
export default __webpack_public_path__ + "static/media/arrow-long-left-r.29b447c29874c0ff580847e7614516db.svg";
export { ForwardRef as ReactComponent };